<nz-modal
   nzWrapClassName="ncx-modal"
   [(nzVisible)]="isVisible"
   [nzContent]="modalContent"
   [nzFooter]="modalFooter"
   (nzOnCancel)="handleCancel()"
   [nzMaskClosable]="false">
   <ng-template #modalContent>
      <div [attr.data-component]="'@modals/standard-guidance'">
         <p class="header">Standards Guidance</p>

         <div class="body">
            <section>
               <textarea
                  rows="6"
                  nz-input
                  placeholder="Fill the Standards Guidance value Here"
                  [(ngModel)]="standardGuidenceContent.notes"
                  (ngModelChange)="onChange($event, 'notes')"></textarea>
            </section>
         </div>
      </div>
   </ng-template>

   <ng-template #modalFooter>
      <button
         nz-button
         nzType="default"
         [disabled]="!isLoaded"
         (click)="handleCancel()">
         Cancel
      </button>
      <button
         nz-button
         nzType="primary"
         [nzLoading]="!isLoaded"
         (click)="handleOk()">
         Submit
      </button>
   </ng-template>
</nz-modal>
